import {create} from "zustand";

export const useUserSupport = create((set, get) => ({
  userSupportModaVisible: false,
  handleSupportModal: () => {
    const userSupportModaVisible = !get().userSupportModaVisible;
    set({userSupportModaVisible});
  },
}));
